(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-ann-favorites"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Which state the coupon shows. The real signal is still to be decided
    // (Shopify customer, Klaviyo subscriber, …), so for now it is a URL flag:
    // ?unlocked=1 shows the code, anything else keeps it locked. Swapping this
    // one function over is all that should be needed later.
    function isUnlocked() {
      var params = new URLSearchParams(window.location.search);
      var flag = params.get('unlocked');
      return flag === '1' || flag === 'true';
    }

    var unlocked = isUnlocked();

    document.querySelectorAll('.ps-ann-favorites').forEach(function (section) {
      section.querySelectorAll('[data-ps-locked]').forEach(function (el) {
        el.hidden = unlocked;
      });
      section.querySelectorAll('[data-ps-unlocked]').forEach(function (el) {
        el.hidden = !unlocked;
      });
      section.classList.toggle('is-unlocked', unlocked);
    });

    document.querySelectorAll('[data-ps-copy]').forEach(function (btn) {
      var label = btn.querySelector('[data-ps-copy-label]');
      var reset;

      btn.addEventListener('click', async function () {
        var code = btn.dataset.code || '';
        if (!code) return;

        try {
          await navigator.clipboard.writeText(code);
        } catch (err) {
          // Safari over HTTP and older browsers: fall back to a throwaway input.
          // Parked off-screen so appending it cannot shift the layout, and
          // readonly so mobile keyboards stay down.
          var tmp = document.createElement('input');
          tmp.value = code;
          tmp.setAttribute('readonly', 'readonly');
          tmp.setAttribute('aria-hidden', 'true');
          tmp.style.cssText = 'position:fixed;top:0;left:-9999px;opacity:0;pointer-events:none;';
          document.body.appendChild(tmp);
          tmp.select();
          tmp.setSelectionRange(0, code.length);
          try {
            document.execCommand('copy');
          } catch (e) {
            document.body.removeChild(tmp);
            return;
          }
          document.body.removeChild(tmp);
        }

        // Inline confirmation only — a dialog would block every later event.
        if (label) label.textContent = btn.dataset.copiedLabel || 'Copied';
        clearTimeout(reset);
        reset = setTimeout(function () {
          if (label) label.textContent = btn.dataset.label || 'Copy';
        }, 2000);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-ann-kit"] && !Shopify.designMode) return;
  try {
    
  // The tap handler is always bound, never gated on a hover check: hybrids
  // (touchscreen laptops, iPad with a mouse) report hover:hover yet are tapped,
  // and the capability can change mid-session when a mouse is plugged in.
  // The CSS hover rules are the ones scoped to @media (hover: hover).
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-ps-ann-collage]').forEach(function (collage) {
      collage.setAttribute('role', 'button');
      collage.setAttribute('tabindex', '0');
      collage.setAttribute('aria-expanded', 'false');

      function toggle() {
        var open = collage.classList.toggle('is-open');
        collage.setAttribute('aria-expanded', open ? 'true' : 'false');
      }

      collage.addEventListener('click', toggle);

      collage.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        toggle();
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-ann-live"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (!window.Swiper) return;

    var mobile = window.matchMedia('(max-width: 768px)');
    var instances = new WeakMap();

    function sync(gallery) {
      if (mobile.matches && !instances.get(gallery)) {
        instances.set(gallery, new Swiper(gallery, {
          slidesPerView: 1.25,
          spaceBetween: 16,
          slidesOffsetBefore: 20,
          slidesOffsetAfter: 20,
          watchOverflow: true,
          pagination: { el: gallery.querySelector('.swiper-pagination'), clickable: true }
        }));
      } else if (!mobile.matches && instances.get(gallery)) {
        instances.get(gallery).destroy(true, true);
        instances.delete(gallery);
      }
    }

    function onBreakpointChange(handler) {
      if (typeof mobile.addEventListener === 'function') mobile.addEventListener('change', handler);
      else if (typeof mobile.addListener === 'function') mobile.addListener(handler);
    }

    document.querySelectorAll('.ps-ann-live__gallery').forEach(function (gallery) {
      sync(gallery);
      onBreakpointChange(function () { sync(gallery); });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-article"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.ps-article .keep-reading .swiper').forEach(function (el) {
      new Swiper(el, {
        slidesPerView: 1.4,
        spaceBetween: 20,
        breakpoints: {
          768: { slidesPerView: 3, spaceBetween: 20 },
        },
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-blog-grid"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.ps-blog-grid').forEach(function (section) {
      const filterSelect = section.querySelector('[data-filter-select]');
      const grid = section.querySelector('.articles-grid');
      const paginationWrapper = section.querySelector('[data-pagination-wrapper]');

      if (filterSelect) {
        filterSelect.addEventListener('change', function () {
          window.location.href = filterSelect.value;
        });
      }

      function bindLoadMore() {
        const loadMore = section.querySelector('[data-load-more]');
        if (!loadMore || !grid || !paginationWrapper) return;

        loadMore.addEventListener('click', function (event) {
          event.preventDefault();
          if (loadMore.dataset.loading === 'true') return;

          const nextUrl = loadMore.getAttribute('href');
          if (!nextUrl) return;

          loadMore.dataset.loading = 'true';
          loadMore.textContent = 'LOADING...';
          loadMore.style.pointerEvents = 'none';

          fetch(nextUrl)
            .then(function (response) {
              return response.text();
            })
            .then(function (html) {
              const doc = new DOMParser().parseFromString(html, 'text/html');
              const nextSection = doc.querySelector('.ps-blog-grid[data-section-id="{{ section.id }}"]') || doc.querySelector('.ps-blog-grid');
              if (!nextSection) return;

              const newCards = nextSection.querySelectorAll('.articles-grid .article-card');
              newCards.forEach(function (card) {
                grid.appendChild(card);
              });

              const nextLoadMore = nextSection.querySelector('[data-load-more]');
              if (nextLoadMore) {
                loadMore.setAttribute('href', nextLoadMore.getAttribute('href'));
                loadMore.textContent = 'LOAD MORE';
                loadMore.style.pointerEvents = '';
                loadMore.dataset.loading = 'false';
              } else {
                paginationWrapper.remove();
              }
            })
            .catch(function () {
              loadMore.textContent = 'LOAD MORE';
              loadMore.style.pointerEvents = '';
              loadMore.dataset.loading = 'false';
            });
        });
      }

      bindLoadMore();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-collection-grid"] && !Shopify.designMode) return;
  try {
    
	document.addEventListener('DOMContentLoaded', function () {
		document.querySelectorAll('.ps-collection-grid').forEach(function (section) {
				const filterDrawer = section.querySelector('[data-ps-filter-drawer]');
				const openFilterButton = section.querySelector('[data-ps-filter-open]');
				const closeFilterButton = section.querySelector('[data-ps-filter-close]');
				const applyFilterButton = section.querySelector('[data-ps-filter-apply]');
				const mobileSortSelect = section.querySelector('[data-ps-mobile-sort]');

				function closeDrawer() {
					if (!filterDrawer) return;
					filterDrawer.classList.remove('is-open');
					filterDrawer.setAttribute('aria-hidden', 'true');
					document.body.style.overflow = '';
				}

				function openDrawer() {
					if (!filterDrawer) return;
					filterDrawer.classList.add('is-open');
					filterDrawer.setAttribute('aria-hidden', 'false');
					document.body.style.overflow = 'hidden';
				}

				if (openFilterButton) {
					openFilterButton.addEventListener('click', openDrawer);
				}

				if (closeFilterButton) {
					closeFilterButton.addEventListener('click', closeDrawer);
				}

				if (filterDrawer) {
					filterDrawer.addEventListener('click', function (event) {
						if (event.target === filterDrawer) {
							closeDrawer();
						}
					});
				}

				if (applyFilterButton) {
					applyFilterButton.addEventListener('click', function () {
						const url = new URL(window.location.href);
						if (mobileSortSelect && mobileSortSelect.value) {
							url.searchParams.set('sort_by', mobileSortSelect.value);
						}
						window.location.href = url.toString();
					});
				}

				document.addEventListener('keydown', function (event) {
					if (event.key === 'Escape') {
						closeDrawer();
					}
				});

			section.querySelectorAll('[data-ps-variant-select]').forEach(function (variantSelect) {
				variantSelect.addEventListener('change', function () {
					const card = variantSelect.closest('.ps-product-card');
					if (!card) return;

					const selected = variantSelect.options[variantSelect.selectedIndex];
					const addButton = card.querySelector('[data-ps-add-to-cart]');
					const image = card.querySelector('.product-image img');
					const priceEl = card.querySelector('.product-price');
					const compareEl = card.querySelector('.product-compare-price');

					if (addButton) {
						addButton.dataset.variantId = selected.value;
						const isAvailable = selected.dataset.available === 'true';
						addButton.disabled = !isAvailable;
						addButton.textContent = isAvailable ? 'Add to Cart' : 'Sold Out';
					}

					if (image && selected.dataset.image) {
						image.src = selected.dataset.image;
					}

					if (priceEl && selected.dataset.price) {
						priceEl.textContent = selected.dataset.price;
					}

					if (selected.dataset.comparePrice) {
						if (compareEl) {
							compareEl.textContent = selected.dataset.comparePrice;
							compareEl.style.display = '';
						} else if (priceEl) {
							const newCompare = document.createElement('p');
							newCompare.className = 'product-compare-price';
							newCompare.textContent = selected.dataset.comparePrice;
							priceEl.insertAdjacentElement('afterend', newCompare);
						}
					} else if (compareEl) {
						compareEl.style.display = 'none';
					}
				});
			});

			section.querySelectorAll('[data-ps-add-to-cart]').forEach(function (button) {
				button.addEventListener('click', function () {
					const variantId = button.dataset.variantId;
					const originalText = button.textContent;

					if (!variantId || button.disabled) return;

					button.disabled = true;
					button.textContent = 'Adding...';

					fetch('/cart/add.js', {
						method: 'POST',
						headers: { 'Content-Type': 'application/json' },
						body: JSON.stringify({ id: variantId, quantity: 1 }),
					})
						.then(function (response) {
							if (!response.ok) throw new Error('Add to cart failed');
							return fetch('/cart.js').then(function (cartResponse) {
								return cartResponse.json();
							});
						})
						.then(function (cart) {
							button.textContent = 'Added!';

							document.dispatchEvent(
								new CustomEvent('cart:update', {
									bubbles: true,
									detail: {
										resource: cart,
										sourceId: button.id || null,
										data: {
											itemCount: cart.item_count,
											variantId: variantId,
											source: 'ps-collection-grid',
										},
									},
								})
							);

							const cartDrawer = document.querySelector('cart-drawer');
							if (cartDrawer) {
								cartDrawer.open();
							}

							// Rebuy SmartCart: open the drawer. This Rebuy build exposes no
							// refresh() - calling it threw a TypeError that rejected the
							// chain even though the add had succeeded, so the .catch() below
							// took over the button reset and the explicit show() never ran.
							// Rebuy repopulates the drawer itself from its own patched fetch
							// on /cart/add.js.
							if (window.Rebuy && window.Rebuy.SmartCart && window.Rebuy.SmartCart.show) {
								window.Rebuy.SmartCart.show();
							}

							setTimeout(function () {
								button.textContent = originalText;
								button.disabled = false;
							}, 1500);
						})
						.catch(function () {
							setTimeout(function () {
								button.textContent = originalText;
								button.disabled = false;
							}, 1800);
						});
				});
			});
		});
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-difference"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.ps-difference .swiper').forEach(function(el) {
      new Swiper(el, {
        slidesPerView: 1.25,
        spaceBetween: 10,
        breakpoints: {
          475: { slidesPerView: 1.65 }
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-dropdowns"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.ps-dropdowns').forEach(function(section) {
      section.querySelectorAll('.dropdown-toggle').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var dropdown = btn.closest('.dropdown');
          var isOpen = dropdown.classList.contains('open');

          section.querySelectorAll('.dropdown.open').forEach(function(openDrop) {
            if (openDrop !== dropdown) openDrop.classList.remove('open');
          });

          dropdown.classList.toggle('open', !isOpen);
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-faqs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var section = document.querySelector('.ps-faqs');
    if (!section) return;

    var mobileSelect = section.querySelector('.faq-mobile-select');
    if (mobileSelect) {
      mobileSelect.addEventListener('change', function() {
        var target = document.getElementById(mobileSelect.value);
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    section.querySelectorAll('.faq-toggle').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var dropdown = btn.closest('.faq-dropdown');
        var isOpen = dropdown.classList.contains('open');

        dropdown.closest('.faq-group').querySelectorAll('.faq-dropdown.open').forEach(function(openDrop) {
          if (openDrop !== dropdown) openDrop.classList.remove('open');
        });

        dropdown.classList.toggle('open', !isOpen);
      });
    });

    var filters = section.querySelectorAll('.filter');

    filters.forEach(function(filter) {
      filter.addEventListener('click', function() {
        filters.forEach(function(f) { f.classList.remove('active'); });
        filter.classList.add('active');
      });
    });

    var faqGroups = section.querySelectorAll('.faq-group');
    if ('IntersectionObserver' in window && faqGroups.length) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            var id = entry.target.id;
            filters.forEach(function(f) {
              f.classList.toggle('active', f.getAttribute('href') === '#' + id);
            });
          }
        });
      }, { rootMargin: '-120px 0px -50% 0px', threshold: 0 });

      faqGroups.forEach(function(group) { observer.observe(group); });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-global-recipes"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.ps-global-recipes .swiper').forEach(function (el) {
      new Swiper(el, {
        slidesPerView: 1.3,
        spaceBetween: 20,
        breakpoints: {
          768: { slidesPerView: 3, spaceBetween: 20 },
        },
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-glow-kit"] && !Shopify.designMode) return;
  try {
    
  // The tap handler is always bound, never gated on a hover check: hybrids
  // (touchscreen laptops, iPad with a mouse) report hover:hover yet are tapped,
  // and the capability can change mid-session when a mouse is plugged in.
  // The CSS hover rules are the ones scoped to @media (hover: hover).
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-ps-glow-collage]').forEach(function (collage) {
      collage.setAttribute('role', 'button');
      collage.setAttribute('tabindex', '0');
      collage.setAttribute('aria-expanded', 'false');

      function toggle() {
        var open = collage.classList.toggle('is-open');
        collage.setAttribute('aria-expanded', open ? 'true' : 'false');
      }

      collage.addEventListener('click', toggle);

      collage.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        toggle();
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-glow-pantry"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Which state the coupon shows. The real signal is still to be decided
    // (Shopify customer, Klaviyo subscriber, …), so for now it is a URL flag:
    // ?unlocked=1 shows the code, anything else keeps it locked. Swapping this
    // one function over is all that should be needed later.
    function isUnlocked() {
      var params = new URLSearchParams(window.location.search);
      var flag = params.get('unlocked');
      return flag === '1' || flag === 'true';
    }

    var unlocked = isUnlocked();

    document.querySelectorAll('.ps-glow-pantry').forEach(function (section) {
      section.querySelectorAll('[data-ps-locked]').forEach(function (el) {
        el.hidden = unlocked;
      });
      section.querySelectorAll('[data-ps-unlocked]').forEach(function (el) {
        el.hidden = !unlocked;
      });
      section.classList.toggle('is-unlocked', unlocked);
    });

    document.querySelectorAll('[data-ps-copy]').forEach(function (btn) {
      var label = btn.querySelector('[data-ps-copy-label]');
      var reset;

      btn.addEventListener('click', async function () {
        var code = btn.dataset.code || '';
        if (!code) return;

        try {
          await navigator.clipboard.writeText(code);
        } catch (err) {
          // Safari over HTTP and older browsers: fall back to a throwaway input.
          // Parked off-screen so appending it cannot shift the layout, and
          // readonly so mobile keyboards stay down.
          var tmp = document.createElement('input');
          tmp.value = code;
          tmp.setAttribute('readonly', 'readonly');
          tmp.setAttribute('aria-hidden', 'true');
          tmp.style.cssText = 'position:fixed;top:0;left:-9999px;opacity:0;pointer-events:none;';
          document.body.appendChild(tmp);
          tmp.select();
          tmp.setSelectionRange(0, code.length);
          try {
            document.execCommand('copy');
          } catch (e) {
            document.body.removeChild(tmp);
            return;
          }
          document.body.removeChild(tmp);
        }

        // Inline confirmation only — a dialog would block every later event.
        if (label) label.textContent = btn.dataset.copiedLabel || 'Copied';
        clearTimeout(reset);
        reset = setTimeout(function () {
          if (label) label.textContent = btn.dataset.label || 'Copy';
        }, 2000);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-glow-track"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (!window.Swiper) return;

    var mobile = window.matchMedia('(max-width: 768px)');
    var instances = new WeakMap();

    function sync(gallery) {
      if (mobile.matches && !instances.get(gallery)) {
        instances.set(
          gallery,
          new Swiper(gallery, {
            slidesPerView: 1.8,
            spaceBetween: 16,
            slidesOffsetBefore: 20,
            slidesOffsetAfter: 20,
            // Hides the dots when everything already fits.
            watchOverflow: true,
            pagination: { el: gallery.querySelector('.swiper-pagination'), clickable: true },
          })
        );
      } else if (!mobile.matches && instances.get(gallery)) {
        instances.get(gallery).destroy(true, true);
        instances.delete(gallery);
      }
    }

    // Safari below 14 has no addEventListener on MediaQueryList, only the
    // deprecated addListener — calling the modern one there throws and the
    // carousel would never initialise.
    function onBreakpointChange(handler) {
      if (typeof mobile.addEventListener === 'function') {
        mobile.addEventListener('change', handler);
      } else if (typeof mobile.addListener === 'function') {
        mobile.addListener(handler);
      }
    }

    document.querySelectorAll('.ps-glow-track__gallery').forEach(function (gallery) {
      sync(gallery);
      onBreakpointChange(function () {
        sync(gallery);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-history"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.ps-history').forEach(function(section) {
      const el = section.querySelector('.swiper');

      new Swiper(el, {
        slidesPerView: 1.35,
        spaceBetween: 20,
        navigation: {
          prevEl: section.querySelector('.swiper-btn-prev'),
          nextEl: section.querySelector('.swiper-btn-next'),
        },
        breakpoints: {
          600:  { slidesPerView: 1.85 },
          800:  { slidesPerView: 2 },
          1024: { slidesPerView: 3 },
          1400: { slidesPerView: 3, spaceBetween: 25 },
        },
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-home-collection-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.ps-home-collection-slider').forEach(function(section) {

      const swipers = [];

      section.querySelectorAll('.product-set').forEach(function(set) {
        const swiper = new Swiper(set.querySelector('.swiper'), {
          slidesPerView: 1.15,
          spaceBetween: 10,
          breakpoints: {
            450:  { slidesPerView: 1.3 },
            600:  { slidesPerView: 2.15 },
            800: { slidesPerView: 3.15 },
            1000: { slidesPerView: 4.15 },
            1200: { slidesPerView: 5, spaceBetween: 15 },
          },
        });
        swipers.push(swiper);
      });

      function switchTo(index) {
        section.querySelectorAll('.product-set').forEach(function(set, i) {
          if (i === index) {
            set.classList.remove('hidden');
            swipers[i].update();
          } else {
            set.classList.add('hidden');
          }
        });
      }

      section.querySelectorAll('.filter-btn').forEach(function(btn) {
        btn.addEventListener('click', function() {
          section.querySelectorAll('.filter-btn').forEach(function(b) {
            b.classList.remove('active');
            b.setAttribute('aria-pressed', 'false');
          });
          btn.classList.add('active');
          btn.setAttribute('aria-pressed', 'true');
          switchTo(parseInt(btn.dataset.index));

          // On mobile the tiles are a scrollable strip, so the one just tapped
          // can sit half off-screen. Scroll the strip itself — NOT
          // scrollIntoView, which walks up and scrolls every scrollable
          // ancestor. The section carries overflow: hidden, and that does not
          // prevent programmatic scrolling: it slid sideways with no scrollbar
          // to bring it back. Guarded on scrollWidth so the desktop grid, which
          // does not scroll, is untouched.
          var strip = btn.parentElement;
          if (strip && strip.scrollWidth > strip.clientWidth) {
            strip.scrollTo({
              left: btn.offsetLeft - (strip.clientWidth - btn.offsetWidth) / 2,
              behavior: 'smooth',
            });
          }
        });
      });

      const select = section.querySelector('.collection-select');
      if (select) {
        function updateSelectColor() {
          const color = select.options[select.selectedIndex].dataset.color;
          if (color) select.style.setProperty('--block-color', color);
        }
        updateSelectColor();
        select.addEventListener('change', function() {
          updateSelectColor();
          switchTo(parseInt(select.value));
        });
      }

      section.querySelectorAll('.variant-select').forEach(function(variantSelect) {
        variantSelect.addEventListener('change', function() {
          const card = variantSelect.closest('.product-card');
          const selected = variantSelect.options[variantSelect.selectedIndex];

          // Update add to cart variant and its availability state
          const btn = card.querySelector('[data-add-to-cart]');
          if (btn) {
            const available = selected.dataset.available === 'true';
            btn.dataset.variantId = variantSelect.value;
            btn.disabled = !available;
            btn.textContent = available ? 'Add to Cart' : 'Sold Out';
          }

          // Update product image
          const newImage = selected.dataset.image;
          const imgEl = card.querySelector('.product-image img');
          if (imgEl && newImage) imgEl.src = newImage;

          // Update prices
          const price = selected.dataset.price;
          const comparePrice = selected.dataset.comparePrice;

          const priceEl = card.querySelector('.product-price');
          const comparePriceEl = card.querySelector('.product-compare-price');

          if (priceEl) priceEl.textContent = price;

          if (comparePrice) {
            if (comparePriceEl) {
              comparePriceEl.textContent = comparePrice;
              comparePriceEl.style.display = '';
            } else {
              const newEl = document.createElement('p');
              newEl.className = 'product-compare-price';
              newEl.textContent = comparePrice;
              priceEl.insertAdjacentElement('afterend', newEl);
            }
          } else {
            if (comparePriceEl) comparePriceEl.style.display = 'none';
          }
        });
      });

      section.querySelectorAll('[data-add-to-cart]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          const variantId = btn.dataset.variantId;
          if (!variantId || btn.disabled) return;

          const originalText = btn.textContent;
          btn.disabled = true;
          btn.textContent = 'Adding...';

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 }),
          })
            .then(function(res) {
              if (!res.ok) throw new Error();
              return fetch('/cart.js').then(function(r) { return r.json(); });
            })
            .then(function(cart) {
              btn.textContent = 'Added!';

              // Horizon: dispatch cart:update with itemCount so cart drawer + bubble update
              document.dispatchEvent(new CustomEvent('cart:update', {
                bubbles: true,
                detail: {
                  resource: cart,
                  sourceId: btn.id || null,
                  data: {
                    itemCount: cart.item_count,
                    variantId: variantId,
                    source: 'ps-collection-slider',
                  },
                },
              }));

              // Horizon: open cart drawer
              const cartDrawer = document.querySelector('cart-drawer');
              if (cartDrawer) {
                cartDrawer.open();
              }

              // Rebuy SmartCart: open the drawer. This Rebuy build exposes no
              // refresh() - calling it threw a TypeError that the chain's
              // .catch() turned into a bogus "Error" button state even though
              // the add had succeeded. Rebuy repopulates the drawer itself from
              // its own patched fetch on /cart/add.js.
              if (window.Rebuy?.SmartCart?.show) {
                window.Rebuy.SmartCart.show();
              }

              setTimeout(function() {
                btn.textContent = originalText;
                btn.disabled = false;
              }, 2000);
            })
            .catch(function() {
              btn.textContent = 'Error';
              setTimeout(function() {
                btn.textContent = originalText;
                btn.disabled = false;
              }, 2000);
            });
        });
      });

    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-home-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.ps-home-hero .swiper').forEach(function(el) {
      new Swiper(el, {
        slidesPerView: 1,
        loop: true,
        autoHeight: true, 
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        pagination: {
          el: el.querySelector('.swiper-pagination'),
          clickable: true,
        },
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-home-loyalty"] && !Shopify.designMode) return;
  try {
    
  class PSLoyaltySteps extends HTMLElement {
    connectedCallback() {
      // Event listeners are wired only once; the ResizeObserver is (re)created
      // below on every connect so scroll-detection survives re-attachment.
      if (this.dataset.initialized !== 'true') {
        this.setupListeners();
      }

      this.resizeObserver = new ResizeObserver(this.updateScrollableState);
      this.resizeObserver.observe(this);
      this.updateScrollableState();
    }

    setupListeners() {
      this.dataset.initialized = 'true';
      this.dragStartX = 0;
      this.dragStartScrollLeft = 0;
      this.isDragging = false;

      // While the marquee runs the strip is overflow:hidden, so manual scrolling stays off.
      this.updateScrollableState = () => {
        const scrollable =
          getComputedStyle(this).overflowX !== 'hidden' && this.scrollWidth > this.clientWidth + 1;

        this.toggleAttribute('data-scrollable', scrollable);
      };

      // Touch pauses the marquee so the copy can be read.
      this.addEventListener('touchstart', () => this.classList.add('is-paused'), { passive: true });
      this.addEventListener('touchend', () => this.classList.remove('is-paused'), { passive: true });
      this.addEventListener('touchcancel', () => this.classList.remove('is-paused'), { passive: true });

      this.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0 || !this.hasAttribute('data-scrollable')) return;

        this.isDragging = true;
        this.dragStartX = event.clientX;
        this.dragStartScrollLeft = this.scrollLeft;
        this.setPointerCapture(event.pointerId);
        this.classList.add('is-dragging');
      });

      this.addEventListener('pointermove', (event) => {
        if (!this.isDragging) return;

        const distance = event.clientX - this.dragStartX;
        this.scrollLeft = this.dragStartScrollLeft - distance;
        event.preventDefault();
      });

      const stopDragging = (event) => {
        if (!this.isDragging) return;

        this.isDragging = false;
        this.classList.remove('is-dragging');

        if (this.hasPointerCapture(event.pointerId)) {
          this.releasePointerCapture(event.pointerId);
        }
      };

      this.addEventListener('pointerup', stopDragging);
      this.addEventListener('pointercancel', stopDragging);
      this.addEventListener('dragstart', (event) => event.preventDefault());

      this.addEventListener('keydown', (event) => {
        if (!this.hasAttribute('data-scrollable')) return;

        const scrollDistance = Math.max(260, this.clientWidth * 0.75);

        if (event.key === 'ArrowRight') {
          this.scrollBy({ left: scrollDistance, behavior: 'smooth' });
        } else if (event.key === 'ArrowLeft') {
          this.scrollBy({ left: -scrollDistance, behavior: 'smooth' });
        } else if (event.key === 'Home') {
          this.scrollTo({ left: 0, behavior: 'smooth' });
        } else if (event.key === 'End') {
          this.scrollTo({ left: this.scrollWidth, behavior: 'smooth' });
        } else {
          return;
        }

        event.preventDefault();
      });
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      this.resizeObserver = null;
    }
  }

  if (!customElements.get('ps-loyalty-steps')) {
    customElements.define('ps-loyalty-steps', PSLoyaltySteps);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-product-comparison"] && !Shopify.designMode) return;
  try {
    
  const swiper = new Swiper('.ps-product-comparison .swiper', {
    slidesPerView: 1.05,
    spaceBetween: 15,
    breakpoints: {
      500: {
        slidesPerView: 1.35,
      },
      650: {
        slidesPerView: 2.05
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-product-faqs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.ps-product-faqs .faq-toggle').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var dropdown = btn.closest('.faq-dropdown');
        var isOpen = dropdown.classList.contains('open');

        document.querySelectorAll('.ps-product-faqs .faq-dropdown.open').forEach(function(openDrop) {
          if (openDrop !== dropdown) openDrop.classList.remove('open');
        });

        dropdown.classList.toggle('open', !isOpen);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-product-main"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var section = document.querySelector('.ps-product-main');
    if (!section) return;

    // Fully disable the StayAI buy box for keyboard and assistive-tech users when
    // the selected variant can't be bought. The .ps-variant-unavailable CSS greys
    // it out and sets pointer-events:none, but pointer-events does not block
    // keyboard focus and leaves the controls in the a11y tree, so also toggle
    // `inert` + aria-disabled on the widget. StayAI injects and re-renders the
    // widget asynchronously, so a MutationObserver re-applies the current state
    // whenever the buy-box subtree changes. updateUI() drives stayaiUnavailable.
    var stayaiUnavailable = false;
    function syncStayaiUnavailable() {
      section.querySelectorAll('.stayai-subscriptions').forEach(function (el) {
        // Manage `inert` via the HTML attribute to match the theme convention
        // (layered-slideshow toggles the attribute and uses [inert] selectors).
        if (el.hasAttribute('inert') !== stayaiUnavailable) el.toggleAttribute('inert', stayaiUnavailable);
        var val = stayaiUnavailable ? 'true' : 'false';
        if (el.getAttribute('aria-disabled') !== val) el.setAttribute('aria-disabled', val);
      });
    }
    if ('MutationObserver' in window) {
      var stayaiHost = section.querySelector('.product-form') || section;

      // This callback writes into the very subtree it watches: the button
      // label and the pack prices are both inside .product-form. Left alone
      // that is an infinite loop — write, observe, write — and the tab locks
      // up. Two things stop it, and both are needed:
      //
      //   1. setText/setHidden only write when the value actually changed, so
      //      a steady state produces no mutations at all.
      //   2. takeRecords() below empties the queue of whatever our own writes
      //      did generate, so the callback is not delivered again for them.
      //
      // A boolean re-entrancy flag would NOT work here: observer callbacks
      // arrive as microtasks, after this function has already returned and
      // cleared the flag.
      var stayaiObserver = new MutationObserver(function () {
        syncStayaiUnavailable();
        // StayAI picks the default purchase type itself, after this script has
        // run, and fires no change event doing so. This is the only signal
        // that the widget settled, so it is where the button and the cards
        // learn they should be showing a subscription price.
        syncAtcPrice();
        syncPackPrices();
        stayaiObserver.takeRecords();
      });
      stayaiObserver.observe(stayaiHost, { childList: true, subtree: true });
    }

    // ── Lightbox ──
    var lightbox   = document.getElementById('ps-lightbox');
    var lbSwiperEl = document.getElementById('ps-lightbox-swiper');
    var counter    = document.getElementById('ps-lightbox-counter');
    var closeBtn   = document.getElementById('ps-lightbox-close');
    var prevBtn    = document.getElementById('ps-lightbox-prev');
    var nextBtn    = document.getElementById('ps-lightbox-next');

    if (!lightbox) return;

    // The main carousel is the one list of images now; the thumbnail rail shows
    // the same set, so reading either would do, but the main slides are the ones
    // carrying the 2000px sources.
    var imageItems = Array.from(section.querySelectorAll('.ps-gallery__slide'));
    var lbImages = imageItems.map(function (item) {
      return {
        src: item.dataset.fullSrc || item.querySelector('img').src,
        alt: item.querySelector('img').alt
      };
    });

    var lbSwiper = null;
    var lbSlides = [];
    // Index the viewer is on while Swiper is unavailable; with Swiper the
    // carousel itself is the source of truth.
    var staticIndex = 0;

    // Built on the first open, not up front, for two reasons: Swiper measures
    // its container on init and the lightbox is display:none until then, and
    // the slides carry the 2000px sources, which would otherwise be requested
    // on every page load.
    function buildViewer() {
      if (lbSlides.length) return;

      var wrapper = lbSwiperEl.querySelector('.swiper-wrapper');
      lbImages.forEach(function (image) {
        var slide = document.createElement('div');
        slide.className = 'swiper-slide';
        // swiper-zoom-container is what the zoom module binds to: it gives
        // pinch, double-tap and panning on the image itself.
        var zoomBox = document.createElement('div');
        zoomBox.className = 'swiper-zoom-container';
        var img = document.createElement('img');
        // Off-screen slides are translated out of the viewport, so lazy keeps
        // the viewer to the image being looked at plus its neighbours.
        img.loading = 'lazy';
        img.src = image.src;
        img.alt = image.alt;
        zoomBox.appendChild(img);
        slide.appendChild(zoomBox);
        wrapper.appendChild(slide);
        lbSlides.push(slide);
      });

      if (typeof Swiper === 'undefined') {
        // The CDN bundle did not load. The viewer still opens and steps through
        // the gallery — one slide shown at a time, arrows doing the moving —
        // it just cannot zoom. Losing the zoom is a smaller regression than
        // losing the enlarged view the desktop grid has always had.
        lightbox.classList.add('ps-lightbox--static');
        console.warn('[ps-product-main] Swiper is unavailable; image viewer opens without zoom.');
        return;
      }

      lbSwiper = new Swiper(lbSwiperEl, {
        zoom: { maxRatio: 4, toggle: true },
      });

      lbSwiper.on('slideChange', function () {
        // Leaving a slide zoomed would make the next one open mid-zoom.
        lbSwiper.zoom.out();
        render();
      });

      // A tap on the letterboxed area around the image closes the viewer, the
      // way it did when it was a bare <img> over the backdrop. Not while
      // zoomed: there that area is image the customer is panning.
      lbSwiper.on('click', function (swiper, e) {
        if (swiper.zoom.scale > 1) return;
        if (e.target.tagName !== 'IMG') close();
      });
    }

    function open(index) {
      // Show first, then build: Swiper needs a laid-out container to measure.
      lightbox.classList.add('active');
      document.body.style.overflow = 'hidden';

      buildViewer();
      staticIndex = index;

      if (lbSwiper) {
        lbSwiper.update();
        lbSwiper.zoom.out();
        lbSwiper.slideTo(index, 0);
      }
      render();
      lightbox.focus();
    }

    function close() {
      if (lbSwiper) lbSwiper.zoom.out();
      lightbox.classList.remove('active');
      document.body.style.overflow = '';
    }

    function render() {
      var current = lbSwiper ? lbSwiper.activeIndex : staticIndex;
      if (!lbSwiper) {
        // Only the current slide is displayed; see .ps-lightbox--static.
        lbSlides.forEach(function (slide, i) {
          slide.classList.toggle('is-current', i === current);
        });
      }
      counter.textContent = (current + 1) + ' / ' + lbImages.length;
      prevBtn.style.visibility = current === 0 ? 'hidden' : 'visible';
      nextBtn.style.visibility = current === lbImages.length - 1 ? 'hidden' : 'visible';
    }

    function prev() {
      if (lbSwiper) return lbSwiper.slidePrev();
      if (staticIndex > 0) { staticIndex--; render(); }
    }

    function next() {
      if (lbSwiper) return lbSwiper.slideNext();
      if (staticIndex < lbImages.length - 1) { staticIndex++; render(); }
    }

    // Slides open the lightbox through the delegated click handler on the
    // carousel (see the gallery setup below). A second, per-slide binding here
    // opened it twice for every click; the slides are <button>s, so Enter and
    // Space already arrive as that same click.

    closeBtn.addEventListener('click', close);
    prevBtn.addEventListener('click', function (e) { e.stopPropagation(); prev(); });
    nextBtn.addEventListener('click', function (e) { e.stopPropagation(); next(); });

    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) close();
    });

    document.addEventListener('keydown', function (e) {
      if (!lightbox.classList.contains('active')) return;
      if (e.key === 'Escape')      close();
      if (e.key === 'ArrowLeft')   prev();
      if (e.key === 'ArrowRight')  next();
    });

    // ── Variant Selector ──
    var form = section.querySelector('.product-form');
    if (!form) return;

    var variantsEl = form.querySelector('.product-variants-json');
    if (!variantsEl) return;

    var variants = JSON.parse(variantsEl.textContent);
    var variantIdInput = form.querySelector('.variant-id-input');
    var atcBtn = form.querySelector('.atc-btn');

    // In BIS mode (out-of-stock variant) the ATC button opens the Back-in-Stock
    // modal instead of submitting the cart form. Works for the static OOS render
    // too, since the button ships with .atc-btn--bis from Liquid.
    atcBtn.addEventListener('click', function (e) {
      if (atcBtn.classList.contains('atc-btn--bis')) {
        e.preventDefault();
        if (window.PSBackInStock) window.PSBackInStock.open(variantIdInput.value);
      }
    });

    var selectedOptions = [];

    function findVariant() {
      var matches = variants.filter(function (v) {
        return v.options.every(function (opt, i) { return opt === selectedOptions[i]; });
      });
      // Prefer a variant we are allowed to offer; a multi-option product could
      // otherwise resolve a combination onto the hidden single.
      return matches.find(isOffered) || matches[0] || null;
    }

    function applyVariant(variant) {
      if (!variant) return;
      selectedOptions = variant.options.slice();
      form.querySelectorAll('.variant-option').forEach(function (optionEl) {
        var idx = parseInt(optionEl.dataset.optionIndex, 10);
        var val = variant.options[idx];
        optionEl.querySelectorAll('.pill').forEach(function (p) {
          p.classList.toggle('active', p.dataset.value === val);
        });
        var labelSpan = optionEl.querySelector('.selected-value');
        if (labelSpan) labelSpan.textContent = val.toUpperCase();
      });
    }

    // Singles are sold through Build a Bundle only. Liquid decided which variants
    // may be offered here; JS must respect the same list, or a stale ?variant=
    // link from an email or ad would put a hidden single back in the buy box.
    var visibleIds = (form.dataset.visibleVariantIds || '')
      .split(',')
      .map(function (id) { return parseInt(id, 10); })
      .filter(Boolean);
    var defaultVariantId = parseInt(form.dataset.defaultVariantId, 10);

    function isOffered(variant) {
      return !visibleIds.length || visibleIds.indexOf(variant.id) !== -1;
    }

    // Determine initial variant: URL param (only if still offered) → Liquid's
    // default → first offered and available → first offered
    var urlVariantId = parseInt(new URLSearchParams(window.location.search).get('variant'), 10);
    var urlVariant = urlVariantId && variants.find(function (v) { return v.id === urlVariantId; });
    var initialVariant =
      (urlVariant && isOffered(urlVariant) ? urlVariant : null) ||
      variants.find(function (v) { return v.id === defaultVariantId; }) ||
      variants.find(function (v) { return v.available && isOffered(v); }) ||
      variants.find(isOffered) ||
      variants[0];

    function formatMoney(cents) {
      return window.PSPrice
        ? window.PSPrice.format(cents)
        : '$' + (cents / 100).toFixed(2);
    }

    var priceEl   = section.querySelector('.prices-wrapper .price');
    var compareEl = section.querySelector('.prices-wrapper .compare-at-price');

    // The price moved out of the header and onto the button, so the button has
    // to track the subscription controls as well as the variant: One-Time vs
    // Subscribe and the delivery frequency change the price without changing
    // the variant, and nothing else on the first screen shows it any more.
    // The quantity field is the shopper's, not ours: it can be mid-edit, empty
    // or over the cap. parseInt and a floor of 1 keep the label honest without
    // touching what they typed — ps-atc-feedback owns correcting the field.
    function currentQuantity() {
      var input = form.querySelector('.ps-qty__input');
      var value = input ? parseInt(input.value, 10) : 1;
      return value > 0 ? value : 1;
    }

    // The label states the total being added, not the unit price: the button
    // sits right next to the quantity stepper, and "Add to Cart $59.99" beside
    // a 10 would promise something other than what the click does. Under a
    // subscription this is the first delivery's total, which is exactly what
    // the cart will charge.
    function atcLabel(variant) {
      if (!variant || !variant.available) return 'Add to Cart';
      // Merch and the gift card keep their own price block; see ps-product-form.
      if (form.dataset.psClassic === '1') return 'Add to Cart';
      // Without ps-price.js (a failed or blocked load) there is no plan-aware
      // price, but Liquid already rendered "Add to Cart $X.XX" — dropping to a
      // bare label here would be a regression. Fall back to the variant's own
      // price, which is what the page showed before this script ran.
      if (!window.PSPrice) return 'Add to Cart ' + formatMoney(variant.price * currentQuantity());
      var shown = window.PSPrice.resolve(variant, window.PSPrice.planId(section));
      if (shown.price == null) return 'Add to Cart ' + formatMoney(variant.price * currentQuantity());
      return 'Add to Cart ' + window.PSPrice.format(shown.price * currentQuantity());
    }

    function currentVariant() {
      var id = parseInt(variantIdInput.value, 10);
      return variants.find(function (v) { return v.id === id; }) || null;
    }

    // Every write below goes through these two.
    //
    // The StayAI MutationObserver watches .product-form with subtree:true, and
    // the button label and the pack prices are inside that form. An
    // unconditional write from inside the observer callback re-triggers the
    // observer, which writes again — the page locks up. Writing only when the
    // value actually changes makes the cycle converge on the first pass, which
    // is the same discipline syncStayaiUnavailable already follows.
    function setText(el, value) {
      if (el && el.textContent !== value) el.textContent = value;
    }

    function setHidden(el, value) {
      if (el && el.hidden !== value) el.hidden = value;
    }

    // "Add to Cart $9.59" fits; "Add to Cart $947.99" on a big box does not, and
    // button.btn forces nowrap, so the label was clipped. Shrink the type to fit
    // rather than wrap — a two-line CTA changes the button's height on every
    // long price, which is worse than a point of type.
    //
    // Measured in a throwaway span in <body>, never by writing trial sizes onto
    // the button: the button lives inside .product-form, which StayAI observes
    // with subtree:true, so every write is a mutation that calls us back. One
    // write, only when the value actually changes, is what makes that converge —
    // the same discipline setText follows.
    var atcMeter = null;

    function measureAtcLabel(text, size) {
      if (!atcMeter) {
        atcMeter = document.createElement('span');
        atcMeter.setAttribute('aria-hidden', 'true');
        atcMeter.style.cssText = 'position:absolute;left:-9999px;top:0;white-space:nowrap;visibility:hidden;';
        document.body.appendChild(atcMeter);
      }
      var cs = window.getComputedStyle(atcBtn);
      atcMeter.style.fontFamily = cs.fontFamily;
      atcMeter.style.fontWeight = cs.fontWeight;
      // In em, not the computed px: that is taken from the button's current,
      // possibly already shrunk size, and would under-measure larger trials.
      atcMeter.style.letterSpacing = '0.05em';
      atcMeter.style.textTransform = cs.textTransform;
      atcMeter.style.fontSize = size + 'px';
      atcMeter.textContent = text;
      return atcMeter.getBoundingClientRect().width;
    }

    function fitAtcLabel() {
      if (!atcBtn) return;

      var cs = window.getComputedStyle(atcBtn);
      // The back-in-stock label is long by nature and wraps by design (see the
      // .atc-btn--bis rules); leave it alone.
      if (atcBtn.classList.contains('atc-btn--bis')) {
        if (atcBtn.style.fontSize !== '') atcBtn.style.fontSize = '';
        return;
      }

      var base = parseFloat(cs.getPropertyValue('--ps-atc-font-size')) || 16;
      var room = atcBtn.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
      if (!(room > 0)) return;

      var size = base;
      // 12px is the floor: below that the CTA stops reading as the primary
      // action. Half-point steps, and a hard stop so a pathological string
      // cannot spin here.
      while (size > 12 && measureAtcLabel(atcBtn.textContent, size) > room) {
        size -= 0.5;
      }

      var value = size < base ? size + 'px' : '';
      if (atcBtn.style.fontSize !== value) atcBtn.style.fontSize = value;
    }

    function setAtcLabel(text) {
      setText(atcBtn, text);
      fitAtcLabel();
    }

    function syncAtcPrice() {
      // The button is only disabled with an available variant while an add is
      // in flight. Writing "Adding..." is itself a mutation inside .product-form,
      // so the StayAI observer calls straight back in here; without this guard it
      // replaced "Adding..." with the price for the whole request. updateUI()
      // restores the label once the add settles.
      if (atcBtn && atcBtn.disabled) return;
      var variant = currentVariant();
      if (variant && variant.available) setAtcLabel(atcLabel(variant));
    }

    // Both steppers (buy box and sticky bar) are delegated from the document and
    // report through this event, so the label follows either one.
    document.addEventListener('ps:quantity', syncAtcPrice);

    // The label is sized against the button, so it has to be re-fitted whenever
    // the button changes width.
    var atcFitTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(atcFitTimer);
      atcFitTimer = setTimeout(fitAtcLabel, 120);
    });

    // The first fit can run before Futura has loaded, against the fallback face.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(fitAtcLabel);
    }

    // The label and the pack cards follow the plan through change events and the
    // StayAI observer. Neither fires when the selection changes by property — a
    // form restored from the back/forward cache, or a script setting .checked —
    // so the sticky bar, which polls, could disagree with the button beside it.
    // Resync on pageshow, and poll the plan the same way the sticky bar does.
    window.addEventListener('pageshow', function () {
      syncAtcPrice();
      syncPackPrices();
    });
    if (window.PSPrice) {
      var lastPlanSeen = window.PSPrice.planId(section);
      setInterval(function () {
        var planNow = window.PSPrice.planId(section);
        if (planNow !== lastPlanSeen) {
          lastPlanSeen = planNow;
          syncAtcPrice();
          syncPackPrices();
        }
      }, 500);
    }

    // Each pack card prices its own variant, against the same plan the button
    // uses — the design shows the subscription price on the card, so toggling
    // Subscribe has to move every card, not just the selected one.
    var packCards = Array.from(form.querySelectorAll('.pill.ps-pack'));

    function syncPackPrices() {
      // packCards is assigned below this declaration, and the StayAI observer
      // can fire before that line runs.
      if (!packCards || !packCards.length || !window.PSPrice) return;
      var plan = window.PSPrice.planId(section);

      packCards.forEach(function (card) {
        var id = parseInt(card.dataset.variantId, 10);
        var variant = variants.find(function (v) { return v.id === id; });
        if (!variant) return;

        var shown = window.PSPrice.resolve(variant, plan);
        var priceEl = card.querySelector('.ps-pack__price');
        var compareEl = card.querySelector('.ps-pack__compare');
        var saveEl = card.querySelector('.ps-pack__save');

        setText(priceEl, window.PSPrice.format(shown.price));

        if (shown.compareAt) {
          setText(compareEl, window.PSPrice.format(shown.compareAt));
          setHidden(compareEl, false);
        } else {
          setHidden(compareEl, true);
        }

        // Whole dollars, rounded DOWN: a saving is a claim, and $7.20 shown as
        // "SAVE $8" would overstate it. Under a dollar there is nothing worth
        // a badge.
        var saved = shown.compareAt ? Math.floor((shown.compareAt - shown.price) / 100) : 0;
        if (saved >= 1) {
          setText(saveEl, 'Save $' + saved);
          setHidden(saveEl, false);
        } else {
          setHidden(saveEl, true);
        }
      });
    }

    // StayAI injects and re-renders its widget asynchronously, so bind to the
    // section and filter rather than to the controls themselves — the same
    // approach the sticky bar takes in custom.js.
    section.addEventListener('change', function (e) {
      var name = e.target && e.target.name;
      if (name === 'purchaseType' || name === 'stayai_selling_plan') {
        syncAtcPrice();
        syncPackPrices();
      }
    });

    function updateUI(variant, skipHistory) {
      // Keep the hidden id and URL param in sync with the resolved variant. On a
      // null variant (selected option combo matches no variant) we CLEAR them, so
      // no consumer — cart submit, Enter-key submit, sticky bar, BIS modal — can
      // act on the previously selected variant.
      variantIdInput.value = variant ? variant.id : '';
      if (!skipHistory) {
        var url = new URL(window.location.href);
        if (variant) {
          url.searchParams.set('variant', variant.id);
        } else {
          url.searchParams.delete('variant');
        }
        history.replaceState({}, '', url.toString());
      }

      // Three states:
      //  - in stock          → live Add to Cart (submit)
      //  - out of stock       → Back-in-Stock trigger for THIS variant (type=button);
      //                         the click handler opens the Klaviyo BIS modal.
      //  - no matching variant → disable. variantIdInput.value still holds the previous
      //                         variant (the guard above only updates it when `variant`
      //                         is truthy), so entering BIS mode here would subscribe the
      //                         customer to the WRONG variant. Stay out of BIS mode.
      if (variant && variant.available) {
        atcBtn.classList.remove('atc-btn--bis');
        setAtcLabel(atcLabel(variant));
        atcBtn.disabled = false;
        atcBtn.type = 'submit';
      } else if (variant) {
        atcBtn.classList.add('atc-btn--bis');
        setAtcLabel('Notify me when back in stock');
        atcBtn.disabled = false;
        atcBtn.type = 'button';
      } else {
        atcBtn.classList.remove('atc-btn--bis');
        setAtcLabel('Unavailable');
        atcBtn.disabled = true;
        atcBtn.type = 'button';
      }

      // Grey out and block the StayAI purchase-type / frequency controls when the
      // selected variant can't be bought (out of stock or no matching variant):
      // buying isn't possible, so One-Time / Subscribe & Save must not be active.
      // Toggling a class on the section (not the StayAI nodes) keeps this working
      // regardless of when StayAI asynchronously injects its buy box — the CSS
      // matches once it renders.
      stayaiUnavailable = !(variant && variant.available);
      section.classList.toggle('ps-variant-unavailable', stayaiUnavailable);
      syncStayaiUnavailable();
      // The label was fitted above, while this class still hid the quantity
      // stepper and the button had the whole row. Leaving a sold-out pack for
      // an available one brings the stepper back and narrows the button, so
      // fit again against the width it has now.
      fitAtcLabel();

      if (variant && priceEl) {
        priceEl.textContent = formatMoney(variant.price);
        if (compareEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            compareEl.textContent = formatMoney(variant.compare_at_price);
            compareEl.style.display = '';
          } else {
            compareEl.style.display = 'none';
          }
        }
      }

      if (variant && variant.featured_image) {
        // The variant's own shot takes the leading slide. Its thumbnail has to
        // follow, or the rail would show the previous variant's packaging next
        // to the new one — the two are separate <img>s now that the gallery is
        // a carousel plus a rail rather than a single grid.
        //
        // Sized to match what Liquid renders (1200 slide, 2000 lightbox, 200
        // thumbnail): featured_image.src is the original upload, and an 80px
        // thumbnail was downloading the full-size file.
        var variantSrc = variant.featured_image.src;
        var sized = function (w) {
          return variantSrc + (variantSrc.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
        };
        var firstItem = section.querySelector('.ps-gallery__slide');
        if (firstItem) {
          var img = firstItem.querySelector('img');
          var changed = firstItem.dataset.variantSrc !== variantSrc;
          firstItem.dataset.variantSrc = variantSrc;
          if (img) img.src = sized(1200);
          firstItem.dataset.fullSrc = sized(2000);
          // keep lightbox in sync
          if (lbImages[0]) lbImages[0].src = sized(2000);
          // The viewer builds its slides once; after that the <img> shown is in
          // lbSlides, not lbImages, so reopening showed the previous packaging.
          if (lbSlides[0]) {
            var lbSlideImg = lbSlides[0].querySelector('img');
            if (lbSlideImg) lbSlideImg.src = sized(2000);
          }

          // Bring the carousel back to the slide that just changed. Otherwise a
          // shopper browsing the third photo picks another pack and sees nothing
          // happen — the new packaging lands on a slide that is off screen.
          // Only when the image really changed, so a variant sharing the same
          // shot does not yank them back. The instance is read off the element
          // (Swiper stores it there) rather than a variable from the gallery
          // setup further down, which is not in scope yet on the first call.
          var carousel = firstItem.closest('.swiper-initialized');
          if (changed && carousel && carousel.swiper && carousel.swiper.activeIndex !== 0) {
            carousel.swiper.slideTo(0);
          }
        }
        var firstThumb = section.querySelector('.ps-gallery__thumb-btn img');
        if (firstThumb) firstThumb.src = sized(200);
      }
    }

    applyVariant(initialVariant);
    // Keep the incoming ?variant= only when it survived the offered check —
    // otherwise the address bar would keep pointing at a variant the buy box no
    // longer shows, and sharing that link would spread it further.
    updateUI(initialVariant, !!(urlVariant && isOffered(urlVariant)));
    // Prices the cards for whatever purchase type is selected right now; the
    // StayAI observer re-runs this once the widget settles on its default.
    syncPackPrices();

    form.querySelectorAll('.pill').forEach(function (pill) {
      pill.addEventListener('click', function () {
        var optionIndex = parseInt(pill.dataset.optionIndex, 10);
        var value = pill.dataset.value;

        selectedOptions[optionIndex] = value;

        var optionEl = form.querySelector('.variant-option[data-option-index="' + optionIndex + '"]');
        optionEl.querySelectorAll('.pill').forEach(function (p) {
          p.classList.toggle('active', p.dataset.value === value);
          p.setAttribute('aria-pressed', p.dataset.value === value ? 'true' : 'false');
        });

        var labelSpan = optionEl.querySelector('.selected-value');
        if (labelSpan) labelSpan.textContent = value.toUpperCase();

        updateUI(findVariant());
      });
    });

    // ── Sticky media column: keep the whole column reachable ──
    // See the .media-column rule. Re-measured on resize and whenever the
    // column's own height changes (images loading, the rail initialising).
    var mediaColumn = section.querySelector('.media-column');
    if (mediaColumn && window.ResizeObserver) {
      var STICKY_TOP = 100;
      var STICKY_BOTTOM_GAP = 24;
      var syncStickyTop = function () {
        var room = window.innerHeight - STICKY_TOP;
        var height = mediaColumn.getBoundingClientRect().height;
        var top = height > room
          ? window.innerHeight - height - STICKY_BOTTOM_GAP
          : STICKY_TOP;
        var value = Math.round(top) + 'px';
        if (mediaColumn.style.getPropertyValue('--ps-media-sticky-top') !== value) {
          mediaColumn.style.setProperty('--ps-media-sticky-top', value);
        }
      };
      new ResizeObserver(syncStickyTop).observe(mediaColumn);
      window.addEventListener('resize', syncStickyTop);
      syncStickyTop();
    }

    // ── Description: three lines and a Read more, on a phone ──
    // The clamp is applied from here rather than from CSS so that a page where
    // this script never ran still shows the whole description. The toggle is
    // only revealed once the text has been measured as genuinely taller than
    // the clamp — otherwise "Read more" would sit under a two-line paragraph
    // and expand nothing.
    var descEl = section.querySelector('[data-ps-description-text]');
    var descToggle = section.querySelector('[data-ps-description-toggle]');

    if (descEl && descToggle) {
      var descQuery = window.matchMedia('(max-width: 768px)');
      var descExpanded = false;

      function syncDescription() {
        if (!descQuery.matches) {
          descEl.classList.remove('is-clamped');
          descToggle.hidden = true;
          return;
        }

        // Measure with the clamp on: scrollHeight is the full text, clientHeight
        // the three visible lines. A couple of pixels of slack keeps sub-pixel
        // line heights from reporting an overflow that is not there.
        descEl.classList.add('is-clamped');
        var overflows = descEl.scrollHeight - descEl.clientHeight > 2;

        descToggle.hidden = !overflows;
        if (!overflows) {
          descEl.classList.remove('is-clamped');
          descExpanded = false;
          return;
        }

        descEl.classList.toggle('is-clamped', !descExpanded);
        descToggle.textContent = descExpanded ? 'Read less' : 'Read more';
        descToggle.setAttribute('aria-expanded', descExpanded ? 'true' : 'false');
      }

      descToggle.addEventListener('click', function () {
        descExpanded = !descExpanded;
        descEl.classList.toggle('is-clamped', !descExpanded);
        descToggle.textContent = descExpanded ? 'Read less' : 'Read more';
        descToggle.setAttribute('aria-expanded', descExpanded ? 'true' : 'false');
      });

      // addEventListener on a MediaQueryList is Safari 14+; addListener covers
      // the rest, and the theme still ships to older iOS.
      if (descQuery.addEventListener) {
        descQuery.addEventListener('change', syncDescription);
      } else if (descQuery.addListener) {
        descQuery.addListener(syncDescription);
      }

      syncDescription();
    }

    // ── Gallery: main carousel linked to the thumbnail rail ──
    // Swiper's Thumbs module owns the relationship between the two: clicking a
    // thumbnail moves the main slide, swiping the main slide highlights and
    // scrolls to its thumbnail, and the active thumbnail gets
    // .swiper-slide-thumb-active for the CSS to style. Nothing here
    // synchronises them by hand.
    var galleryEl = section.querySelector('.ps-gallery');
    if (galleryEl) {
      var galleryMainEl = galleryEl.querySelector('.ps-gallery__main');
      var galleryMainSwiper = null;

      if (typeof Swiper !== 'undefined') {
        // watchSlidesProgress is required by Thumbs — without it the module
        // cannot tell which thumbnail is current.
        var galleryThumbsSwiper = new Swiper(galleryEl.querySelector('.ps-gallery__thumbs'), {
          direction: 'horizontal',
          slidesPerView: 'auto',
          spaceBetween: 12,
          freeMode: true,
          watchSlidesProgress: true,
          navigation: {
            prevEl: galleryEl.querySelector('.ps-gallery__nav--prev'),
            nextEl: galleryEl.querySelector('.ps-gallery__nav--next'),
          },
          // The rail turns vertical alongside the CSS grid flip. Swiper 11
          // handles a direction change inside breakpoints itself (it calls
          // changeDirection internally), so no resize handler is needed.
          breakpoints: {
            769: {
              direction: 'vertical',
              slidesPerView: 'auto',
              spaceBetween: 15,
            },
          },
        });

        galleryMainSwiper = new Swiper(galleryMainEl, {
          spaceBetween: 0,
          thumbs: { swiper: galleryThumbsSwiper },
        });

        // Swiper's Thumbs module switches slides on its own 'tap', which only
        // pointer input produces. Enter or Space on a focused thumbnail button
        // fires a plain click and nothing else, so keyboard and screen-reader
        // users could not change the image. One delegated click covers both:
        // for a mouse click Thumbs has already moved and slideTo is a no-op.
        var thumbsRail = galleryEl.querySelector('.ps-gallery__thumbs');
        if (thumbsRail) {
          thumbsRail.addEventListener('click', function (e) {
            var btn = e.target.closest('.ps-gallery__thumb-btn');
            if (!btn || !galleryMainSwiper) return;
            var slide = btn.closest('.swiper-slide');
            var index = slide ? Array.prototype.indexOf.call(slide.parentNode.children, slide) : -1;
            if (index > -1 && index !== galleryMainSwiper.activeIndex) {
              galleryMainSwiper.slideTo(index);
            }
          });
        }
      }

      // Zooming happens in the lightbox, not in the carousel. Bound whether or
      // not Swiper initialised — without it the slides just stack, and opening
      // an image has to keep working. Delegated, and safe against swipes:
      // Swiper's preventClicks swallows the click a drag leaves behind before
      // it reaches this handler.
      galleryMainEl.addEventListener('click', function (e) {
        var btn = e.target.closest('.ps-gallery__slide');
        if (!btn) return;

        var index = Number(btn.dataset.index);
        // One slide fills the frame, so a click always lands on the active one;
        // the guard is here for the stacked no-Swiper fallback, where every
        // slide is on screen at once.
        if (galleryMainSwiper && index !== galleryMainSwiper.activeIndex) {
          galleryMainSwiper.slideTo(index);
          return;
        }
        open(index);
      });
    }

    // ── Add to Cart → fly to cart, keep the drawer shut ──
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      if (!window.PSAtc) {
        // The feedback asset failed to load. Nothing can add to cart, so make the
        // failure visible instead of leaving a dead button.
        console.error('[ps-atc] ps-atc-feedback.js did not load; add to cart is unavailable.');
        return;
      }
      // No early return on an empty variant id: PSAtc.addToCart rejects with
      // "Please choose an option first.", which the .catch() below announces,
      // instead of a silent dead click.

      var wrapper = form.querySelector('.atc-wrapper');
      var sourceImage = window.PSAtc.productImage();

      atcBtn.disabled = true;
      atcBtn.textContent = 'Adding...';

      window.PSAtc.addToCart(form)
        .then(function () {
          // PSAtc.addToCart already refreshed the header badge.
          // Fly from the Add to Cart button, per the client.
          window.PSAtc.flyToCart(sourceImage, atcBtn);
          window.PSAtc.announce(wrapper, 'added', 'Added to the cart');
          // Back to 1, so the next click cannot silently repeat the quantity.
          window.PSAtc.resetQuantity(form);
        })
        .catch(function (error) {
          var message = (error && error.message) || 'Could not add to cart. Please try again.';
          window.PSAtc.announce(wrapper, 'error', message);
        })
        .then(function () {
          updateUI(findVariant());                     // restores label and enabled state
        });
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-product-manual"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.ps-product-manual').forEach(function(section) {

      const set = section.querySelector('.product-set');
      if (!set) return;

      new Swiper(set.querySelector('.swiper'), {
        slidesPerView: 1.5,
        spaceBetween: 15,
        // Fewer cards than fit in a row (sold-out ones are left out): centre them.
        centerInsufficientSlides: true,
        navigation: {
          prevEl: set.querySelector('.swiper-btn-prev'),
          nextEl: set.querySelector('.swiper-btn-next'),
        },
        breakpoints: {
          600:  { slidesPerView: 1.5 },
          768:  { slidesPerView: 2.5 },
          1025: { slidesPerView: 4, spaceBetween: 20 },
        },
      });

      section.querySelectorAll('.variant-select').forEach(function(variantSelect) {
        variantSelect.addEventListener('change', function() {
          const card = variantSelect.closest('.product-card');

          const btn = card.querySelector('[data-add-to-cart]');
          if (btn) btn.dataset.variantId = variantSelect.value;

          const selected = variantSelect.options[variantSelect.selectedIndex];
          const newImage = selected.dataset.image;
          const imgEl = card.querySelector('.product-image img');
          if (imgEl && newImage) imgEl.src = newImage;

          const price = selected.dataset.price;
          const comparePrice = selected.dataset.comparePrice;

          const priceEl = card.querySelector('.product-price');
          const comparePriceEl = card.querySelector('.product-compare-price');

          if (priceEl) priceEl.textContent = price;

          if (comparePrice) {
            if (comparePriceEl) {
              comparePriceEl.textContent = comparePrice;
              comparePriceEl.style.display = '';
            } else {
              const newEl = document.createElement('p');
              newEl.className = 'product-compare-price';
              newEl.textContent = comparePrice;
              priceEl.insertAdjacentElement('afterend', newEl);
            }
          } else {
            if (comparePriceEl) comparePriceEl.style.display = 'none';
          }
        });
      });

      section.querySelectorAll('[data-add-to-cart]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          const variantId = btn.dataset.variantId;
          const originalText = btn.textContent;
          btn.disabled = true;
          btn.textContent = 'Adding...';

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 }),
          })
            .then(function(res) {
              if (!res.ok) throw new Error();
              return fetch('/cart.js').then(function(r) { return r.json(); });
            })
            .then(function(cart) {
              btn.textContent = 'Added!';

              document.dispatchEvent(new CustomEvent('cart:update', {
                bubbles: true,
                detail: {
                  resource: cart,
                  sourceId: btn.id || null,
                  data: {
                    itemCount: cart.item_count,
                    variantId: variantId,
                    source: 'ps-product-manual',
                  },
                },
              }));

              const cartDrawer = document.querySelector('cart-drawer');
              if (cartDrawer) cartDrawer.open();

              // Rebuy SmartCart: open the drawer. This Rebuy build exposes no
              // refresh() - calling it threw a TypeError that the chain's
              // .catch() turned into a bogus "Error" button state even though
              // the add had succeeded. Rebuy repopulates the drawer itself from
              // its own patched fetch on /cart/add.js.
              if (window.Rebuy?.SmartCart?.show) {
                window.Rebuy.SmartCart.show();
              }

              setTimeout(function() {
                btn.textContent = originalText;
                btn.disabled = false;
              }, 2000);
            })
            .catch(function() {
              btn.textContent = 'Error';
              setTimeout(function() {
                btn.textContent = originalText;
                btn.disabled = false;
              }, 2000);
            });
        });
      });

    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-product-related"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.ps-product-upsell').forEach(function(section) {

      const set = section.querySelector('.product-set');
      if (!set) return;

      new Swiper(set.querySelector('.swiper'), {
        slidesPerView: 1.35,
        spaceBetween: 10,
        breakpoints: {
          600:  { slidesPerView: 2.15 },
          800:  { slidesPerView: 3.15 },
          1000: { slidesPerView: 4.15 },
          1200: { slidesPerView: 5, spaceBetween: 15 },
        },
      });

      section.querySelectorAll('.variant-select').forEach(function(variantSelect) {
        variantSelect.addEventListener('change', function() {
          const card = variantSelect.closest('.product-card');

          const btn = card.querySelector('[data-add-to-cart]');
          if (btn) btn.dataset.variantId = variantSelect.value;

          const selected = variantSelect.options[variantSelect.selectedIndex];
          const newImage = selected.dataset.image;
          const imgEl = card.querySelector('.product-image img');
          if (imgEl && newImage) imgEl.src = newImage;

          const price = selected.dataset.price;
          const comparePrice = selected.dataset.comparePrice;

          const priceEl = card.querySelector('.product-price');
          const comparePriceEl = card.querySelector('.product-compare-price');

          if (priceEl) priceEl.textContent = price;

          if (comparePrice) {
            if (comparePriceEl) {
              comparePriceEl.textContent = comparePrice;
              comparePriceEl.style.display = '';
            } else {
              const newEl = document.createElement('p');
              newEl.className = 'product-compare-price';
              newEl.textContent = comparePrice;
              priceEl.insertAdjacentElement('afterend', newEl);
            }
          } else {
            if (comparePriceEl) comparePriceEl.style.display = 'none';
          }
        });
      });

      section.querySelectorAll('[data-add-to-cart]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          const variantId = btn.dataset.variantId;
          const originalText = btn.textContent;
          btn.disabled = true;
          btn.textContent = 'Adding...';

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 }),
          })
            .then(function(res) {
              if (!res.ok) throw new Error();
              return fetch('/cart.js').then(function(r) { return r.json(); });
            })
            .then(function(cart) {
              btn.textContent = 'Added!';

              document.dispatchEvent(new CustomEvent('cart:update', {
                bubbles: true,
                detail: {
                  resource: cart,
                  sourceId: btn.id || null,
                  data: {
                    itemCount: cart.item_count,
                    variantId: variantId,
                    source: 'ps-product-upsell',
                  },
                },
              }));

              const cartDrawer = document.querySelector('cart-drawer');
              if (cartDrawer) cartDrawer.open();

              // Rebuy SmartCart: open the drawer. This Rebuy build exposes no
              // refresh() - calling it threw a TypeError that the chain's
              // .catch() turned into a bogus "Error" button state even though
              // the add had succeeded. Rebuy repopulates the drawer itself from
              // its own patched fetch on /cart/add.js.
              if (window.Rebuy?.SmartCart?.show) {
                window.Rebuy.SmartCart.show();
              }

              setTimeout(function() {
                btn.textContent = originalText;
                btn.disabled = false;
              }, 2000);
            })
            .catch(function() {
              btn.textContent = 'Error';
              setTimeout(function() {
                btn.textContent = originalText;
                btn.disabled = false;
              }, 2000);
            });
        });
      });

    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-product-stands-out"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-ps-stands-out]').forEach(function (el) {
      if (typeof Swiper === 'undefined') return;
      if (el.querySelectorAll('.swiper-slide').length < 2) return;

      var query = window.matchMedia('(max-width: 768px)');
      var instance = null;
      // Read from the CSS so the inset and the negative margin cannot drift.
      var GUTTER = parseFloat(getComputedStyle(el).getPropertyValue('--ps-stands-out-gutter')) || 20;

      // Built and torn down around the breakpoint rather than disabled through
      // Swiper's own `enabled` option: a disabled instance keeps the transform
      // on .swiper-wrapper, and the desktop grid would sit offset by however far
      // the carousel had been swiped.
      function sync() {
        if (query.matches && !instance) {
          instance = new Swiper(el, {
            // 'auto' plus a CSS width, so the card keeps the file's 292/410 of
            // the viewport at any screen size and the neighbour peeks by the
            // drawn amount instead of a fixed fraction.
            slidesPerView: 'auto',
            spaceBetween: 20,
            watchOverflow: true,
            // Same arrangement the recipes carousel uses: the track runs to both
            // screen edges (negative margins in the CSS) while the first and last
            // slides are inset by the section's own gutter, so the run starts and
            // ends on the content edge and only the middle cards bleed.
            slidesOffsetBefore: GUTTER,
            slidesOffsetAfter: GUTTER,
            pagination: {
              el: el.querySelector('.swiper-pagination'),
              clickable: true,
            },
          });
        } else if (!query.matches && instance) {
          instance.destroy(true, true);
          instance = null;
        }
      }

      if (query.addEventListener) {
        query.addEventListener('change', sync);
      } else if (query.addListener) {
        query.addListener(sync);
      }

      sync();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-recipe-products"] && !Shopify.designMode) return;
  try {
    
  // Section-specific layout only. Card behaviour (variant switching + add-to-cart)
  // is handled globally by assets/ps-product-card.js via the shared card's data-ps-* hooks.
  document.addEventListener('DOMContentLoaded', function () {
    if (!window.Swiper) return;

    document.querySelectorAll('.ps-recipe-products .product-set .swiper').forEach(function (el) {
      new Swiper(el, {
        slidesPerView: 1.35,
        spaceBetween: 10,
        // Mobile: centre the active product with a peek on both sides; the first
        // and last cards align to the edges (centeredSlidesBounds).
        centeredSlides: true,
        centeredSlidesBounds: true,
        // Centre the row when there are fewer products than fit per view.
        centerInsufficientSlides: true,
        // Disable the slider + hide the dots when every product already fits, so the
        // dots only show (incl. desktop) when the slider is actually swipeable.
        watchOverflow: true,
        // Mobile full-bleed: keep a 20px content gutter on the first/last cards (as
        // on the product page), so they don't sit flush against the screen edge.
        // Reset to 0 from 800px up where the carousel is inside the padded content.
        slidesOffsetBefore: 20,
        slidesOffsetAfter: 20,
        pagination: {
          el: el.querySelector('.swiper-pagination'),
          clickable: true,
        },
        breakpoints: {
          // From tablet up the cards sit in a left-aligned row (no centring).
          600:  { slidesPerView: 2.15, centeredSlides: false },
          800:  { slidesPerView: 3.15, centeredSlides: false, slidesOffsetBefore: 0, slidesOffsetAfter: 0 },
          1000: { slidesPerView: 4.15, centeredSlides: false, slidesOffsetBefore: 0, slidesOffsetAfter: 0 },
          1200: { slidesPerView: 5, spaceBetween: 15, centeredSlides: false, slidesOffsetBefore: 0, slidesOffsetAfter: 0 },
        },
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-science-megablock"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.ps-science-megablock').forEach(function(section) {

      // Experts swiper
      const expertsSwiper = new Swiper(section.querySelector('.experts-swiper'), {
        slidesPerView: 1.25,
        spaceBetween: 10,
        navigation: {
          prevEl: section.querySelector('.experts-btn-prev'),
          nextEl: section.querySelector('.experts-btn-next'),
        },
        breakpoints: {
          550: { slidesPerView: 2.15 },
          750: { slidesPerView: 3 },
          1000: { slidesPerView: 4, spaceBetween: 15 }
        },
      });

      // Video swiper
      const videoSwiper = new Swiper(section.querySelector('.video-swiper'), {
        slidesPerView: 1,
        spaceBetween: 15,
        observer: true,
        observeParents: true,
        navigation: {
          prevEl: section.querySelector('.video-btn-prev'),
          nextEl: section.querySelector('.video-btn-next'),
        },
      });

      // Stop playing video on slide change
      videoSwiper.on('slideChange', function() {
        section.querySelectorAll('.video-slide.is-playing').forEach(function(slide) {
          const v = slide.querySelector('video');
          if (v) { v.pause(); v.currentTime = 0; }
          slide.classList.remove('is-playing');
        });
      });

      // Play buttons
      section.querySelectorAll('.video-slide').forEach(function(slide) {
        const btn = slide.querySelector('.play-btn');
        const video = slide.querySelector('video');
        if (!btn || !video) return;

        btn.addEventListener('click', function() {
          section.querySelectorAll('.video-slide.is-playing').forEach(function(s) {
            const v = s.querySelector('video');
            if (v) { v.pause(); v.currentTime = 0; }
            s.classList.remove('is-playing');
          });
          slide.classList.add('is-playing');
          const v = slide.querySelector('video');
          if (v) v.play();
        });

        const videoEl = slide.querySelector('video');
        if (videoEl) videoEl.addEventListener('ended', function() {
          slide.classList.remove('is-playing');
        });
      });



    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-swiper-cards"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.ps-swiper-cards .swiper').forEach(function(el) {
      new Swiper(el, {
        slidesPerView: 2.15,
        spaceBetween: 20,
        breakpoints: {
          1025: { slidesPerView: 5, spaceBetween: 45 },
        },
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-testimonial-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initializeTestimonialSliders(root) {
      const sections = [];

      if (
        root instanceof Element &&
        root.matches('.ps-testimonial-slider')
      ) {
        sections.push(root);
      }

      root.querySelectorAll('.ps-testimonial-slider').forEach(function (section) {
        sections.push(section);
      });

      sections.forEach(function (section) {
        const el = section.querySelector('.swiper');

        if (!el || el.swiper || typeof Swiper === 'undefined') {
          return;
        }

        const slider = new Swiper(el, {
          slidesPerView: 1.15,
          spaceBetween: 20,
          autoHeight: false,
          pagination: {
            el: section.querySelector('.swiper-pagination'),
            clickable: true,
          },
          navigation: {
            prevEl: section.querySelector('.swiper-btn-prev'),
            nextEl: section.querySelector('.swiper-btn-next'),
          },
          breakpoints: {
            500: {
              slidesPerView: 1.5,
            },
            650: {
              slidesPerView: 2.15,
            },
            900: {
              slidesPerView: 2.85,
            },
            1025: {
              slidesPerView: 2.33,
            },
          },
        });

        function updateSlider() {
          if (!slider.destroyed) {
            slider.update();
          }
        }

        section.querySelectorAll('.card-image img').forEach(function (img) {
          if (!img.complete) {
            img.addEventListener('load', updateSlider, { once: true });
          }
        });

        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(updateSlider);
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initializeTestimonialSliders(document);
      });
    } else {
      initializeTestimonialSliders(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initializeTestimonialSliders(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      event.target.querySelectorAll('.ps-testimonial-slider .swiper').forEach(function (el) {
        if (el.swiper) {
          el.swiper.destroy(true, true);
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-trusted-by"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.ps-trusted-by').forEach(function(section) {
      const el = section.querySelector('.swiper'); 

      new Swiper(el, {
        slidesPerView: 1.75,
        spaceBetween: 10,

        breakpoints: {
          550: { slidesPerView: 2.15},
          750: { slidesPerView: 3.15},
          1000: { slidesPerView: 4.15, spaceBetween: 15 },
          1200: { slidesPerView: 5 },
        },
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-you-might-like"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.ps-you-might-like').forEach(function(section) {

      const set = section.querySelector('.product-set');
      if (!set) return;

      new Swiper(set.querySelector('.swiper'), {
        slidesPerView: 1.35,
        spaceBetween: 10,
        breakpoints: {
          600:  { slidesPerView: 2.15 },
          800:  { slidesPerView: 3.15 },
          1000: { slidesPerView: 4.15 },
          1200: { slidesPerView: 5, spaceBetween: 15 },
        },
      });

      section.querySelectorAll('.variant-select').forEach(function(variantSelect) {
        variantSelect.addEventListener('change', function() {
          const card = variantSelect.closest('.product-card');

          const btn = card.querySelector('[data-add-to-cart]');
          if (btn) btn.dataset.variantId = variantSelect.value;

          const selected = variantSelect.options[variantSelect.selectedIndex];
          const newImage = selected.dataset.image;
          const imgEl = card.querySelector('.product-image img');
          if (imgEl && newImage) imgEl.src = newImage;

          const price = selected.dataset.price;
          const comparePrice = selected.dataset.comparePrice;

          const priceEl = card.querySelector('.product-price');
          const comparePriceEl = card.querySelector('.product-compare-price');

          if (priceEl) priceEl.textContent = price;

          if (comparePrice) {
            if (comparePriceEl) {
              comparePriceEl.textContent = comparePrice;
              comparePriceEl.style.display = '';
            } else {
              const newEl = document.createElement('p');
              newEl.className = 'product-compare-price';
              newEl.textContent = comparePrice;
              priceEl.insertAdjacentElement('afterend', newEl);
            }
          } else {
            if (comparePriceEl) comparePriceEl.style.display = 'none';
          }
        });
      });

      section.querySelectorAll('[data-add-to-cart]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          const variantId = btn.dataset.variantId;
          const originalText = btn.textContent;
          btn.disabled = true;
          btn.textContent = 'Adding...';

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 }),
          })
            .then(function(res) {
              if (!res.ok) throw new Error();
              return fetch('/cart.js').then(function(r) { return r.json(); });
            })
            .then(function(cart) {
              btn.textContent = 'Added!';

              document.dispatchEvent(new CustomEvent('cart:update', {
                bubbles: true,
                detail: {
                  resource: cart,
                  sourceId: btn.id || null,
                  data: {
                    itemCount: cart.item_count,
                    variantId: variantId,
                    source: 'ps-you-might-like',
                  },
                },
              }));

              const cartDrawer = document.querySelector('cart-drawer');
              if (cartDrawer) cartDrawer.open();

              // Rebuy SmartCart: open the drawer. This Rebuy build exposes no
              // refresh() - calling it threw a TypeError that the chain's
              // .catch() turned into a bogus "Error" button state even though
              // the add had succeeded. Rebuy repopulates the drawer itself from
              // its own patched fetch on /cart/add.js.
              if (window.Rebuy?.SmartCart?.show) {
                window.Rebuy.SmartCart.show();
              }

              setTimeout(function() {
                btn.textContent = originalText;
                btn.disabled = false;
              }, 2000);
            })
            .catch(function() {
              btn.textContent = 'Error';
              setTimeout(function() {
                btn.textContent = originalText;
                btn.disabled = false;
              }, 2000);
            });
        });
      });

    });
  });

  } catch(e) { console.error(e); }
})();
})();
